import User from '@/model/user.js'

export default {
  state: {
    user: {}
  },
  getters: {
    checkUser: (state) => {
      return state.user
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    }
  },
  actions: {
    checkUser({ commit }) {
      User.checkUser()
        .then((response) => {
          if (response.status == 200) {
            commit('setUser', response.data)
          }
        })
        .catch(({ response }) => {
          if (response.status == 401) {
            this.state.user = {}
          }
        })
    }
  }
}
